import { Box } from "@maysoft/common-component-react";
import TabItem from "./TabItem";

export interface ITabFilter {
    title: string;
    value?: number;
    Icon?: JSX.Element;
    customSuffix?: React.ReactNode;
}

export const Tabs = ({ tabs, value, onChangeTab }: { tabs: ITabFilter[]; value: number; onChangeTab: (tab: ITabFilter, index: number) => void }) => {
    return (
        <Box
            display="flex"
            sx={{
                overflowX: "scroll",
                scrollBehavior: "smooth",
                borderBottom: "1px solid #E4EBF7",
                "::-webkit-scrollbar": {
                    display: "none",
                },
            }}
        >
            {tabs.map((tab, index) => (
                <TabItem
                    item={tab}
                    key={index}
                    isActive={value === tab.value}
                    onClick={() => onChangeTab(tab, index)}
                />
            ))}
        </Box>
    );
};

export default Tabs;
